<script>
    import * as api   from '../../shared/api.js'
    import { saveAs } from 'file-saver'
    import "dino-color-picker"

    export let item

    let working       = false
    let preset        = 'blue'
    let logo          = true
    let size          = 'regular'
    let customText    = null
    let actions       = ['cookies', 'inquiries', 'consent']
    let removeCookies = false
    let privacyPolicy = null
    let previewWindow = null

    let picker = false
    let color  = '#fff'

    const presets = {
        blue: [
            { type: "color" , value: "#ffffff", name: "--main-color"     , title: "Côr do Texto"    },
            { type: "color" , value: "#2e7eed", name: "--bg-color"       , title: "Côr de Fundo"    },
            { type: "color" , value: "#1466d9", name: "--dark-bg-color"  , title: "Côr Secundária"  },
            { type: "color" , value: "#edad2d", name: "--highlight-color", title: "Côr de Destaque" },
            { type: "color" , value: "#ffffff", name: "--btn-color"      , title: "Texto do Botão"  },
            { type: "color" , value: "#1466d9", name: "--btn-bg"         , title: "Fundo do Botão"  },
        ],
        light: [
            { type: "color" , value: "#777777", name: "--main-color"     , title: "Côr do Texto"    },
            { type: "color" , value: "#ffffff", name: "--bg-color"       , title: "Côr de Fundo"    },
            { type: "color" , value: "#eeeeee", name: "--dark-bg-color"  , title: "Côr Secundária"  },
            { type: "color" , value: "#999999", name: "--highlight-color", title: "Côr de Destaque" },
            { type: "color" , value: "#777777", name: "--btn-color"      , title: "Texto do Botão"  },
            { type: "color" , value: "#eeeeee", name: "--btn-bg"         , title: "Fundo do Botão"  },
        ],
        dark: [
            { type: "color" , value: "#ffffff", name: "--main-color"     , title: "Côr do Texto"    },
            { type: "color" , value: "#777777", name: "--bg-color"       , title: "Côr de Fundo"    },
            { type: "color" , value: "#444444", name: "--dark-bg-color"  , title: "Côr Secundária"  },
            { type: "color" , value: "#999999", name: "--highlight-color", title: "Côr de Destaque" },
            { type: "color" , value: "#ffffff", name: "--btn-color"      , title: "Texto do Botão"  },
            { type: "color" , value: "#444444", name: "--btn-bg"         , title: "Fundo do Botão"  },
        ]
    }

    $: custom     = preset ? [ ...presets[preset] ] : custom
    $: text       = customText || defaultText(privacyPolicy)
    $: theme      = preset ? presets[preset] : custom
    $: previewUrl = generatePreviewUrl(logo, size, preset, text, theme, removeCookies, actions )
    $: updatePreviewWindown(previewUrl)

    function defaultText(policy) {
        if(policy)
            return `Ao continuar navegando, você concorda com a nossa <a href="${policy}">Política de Privacidade</a>`
        else 
            return "Ao continuar navegando, você concorda com a nossa Política de Privacidade"
    }

    function updateTheme(item) {
        return evt => {
            preset = null
            custom = custom.map(prop => {
                if(prop.name === item.name) {
                    return { ...prop, value: evt.target.value }
                } else {
                    return { ...prop }
                }
            })            
        }
    }

    function copyBanner() {
        working = true
        const colors = {}
        theme.forEach(item => {
            colors[item.name] = item.value 
        })

        const data = {
            preset: preset || 'light',
            size         , 
            text         , 
            actions      ,
            logo         ,
            colors       ,
            removeCookies,
        }
        return api.post(`/domain/snippet/${item.id}`, data)
            .then(res => {
                working = false
                if(res.status === 200)
                    return res.text()
                else
                    throw `Not 200 (${res.status})`
            })
            .then(snippet => {
                const blob = new Blob([snippet], { type: "text/html; charset=utf-8" })
                saveAs(blob, `script-dogma-${item.domain}.html`)            
            })
            .catch(err => {
                working = false
                console.error(err)
            })

    }

    function generatePreviewUrl(logo, size, preset, text, theme, removeCookies, actions) {
        
        const params = new URLSearchParams("")

        params.set("logo"          , logo)
        params.set("size"          , size)
        params.set("text"          , text)
        params.set("preset"        , preset || 'light')
        params.set("removeCookies" , removeCookies)
        
        actions.forEach(action => {
            params.append("actions" , action)
        })
        
        theme.forEach(item => {
            params.set(item.name, item.value)
        })

        return api.resolve(`/domain/preview/${item.id}?${params.toString()}`)
    }
    
    function updatePreviewWindown(url) {
        if(previewWindow) previewWindow.location = url
    }

    function openPreview() {
        previewWindow = window.open(previewUrl, { width: 1000, height: 700 })
    }

    function showPicker(item) {
        return evt => {
            if(!picker || picker.name !== item.name) {
                picker = item
                color = item.value
            } else {
                picker = false
                color = '#fff'
            }
        }
    }

    function onColorChange(evt) {
        updateTheme(picker)(evt)
    }
</script>

<div class="container">
    <div class="settings">
        <div>
            <button class="ui blue button" 
                    class:disabled={working} 
                    on:click={copyBanner}>
                <i class="download icon"></i>
                Download do Código
            </button>
            <button class="ui blue button" on:click={openPreview}>
                <i class="window restore outline icon"></i>
                Preview
              </button>
        </div>
        <div class="section">
            <h3>Aparência</h3>
            <div class="columns">
                <div class="column one section themes">
                    <h4>Logo</h4>
                    <div class="ui toggle checkbox">
                        <input type="checkbox" bind:checked={logo}>
                        <label>{logo ? 'Sim' : 'Não'}</label>
                    </div>
                    <h4>Tamanho</h4>
                    <div class="ui toggle checkbox">
                        <input type="radio" value="regular" bind:group={size}>
                        <label>Normal</label>
                    </div>
                    <div class="ui toggle checkbox">
                        <input type="radio" value="compact" bind:group={size}>
                        <label>Compacto</label>
                    </div>
                    <h4>Tema</h4>
                    <div class="ui toggle checkbox">
                        <input type="radio" value="blue" bind:group={preset}>
                        <label>Azul</label>
                    </div>
                    <div class="ui toggle checkbox">
                        <input type="radio" value="light" bind:group={preset}>
                        <label>Claro</label>
                    </div>
                    <div class="ui toggle checkbox">
                        <input type="radio" value="dark" bind:group={preset}>
                        <label>Escuro</label>
                    </div>
                    <h4>Funções</h4>
                    <div class="ui toggle checkbox">
                        <input type="checkbox" value="cookies" bind:group={actions}>
                        <label>Cookies</label>
                    </div>
                    <div class="ui toggle checkbox">
                        <input type="checkbox" value="consent" bind:group={actions}>
                        <label>Consentimentos</label>
                    </div>
                    <div class="ui toggle checkbox">
                        <input type="checkbox" value="inquiries" bind:group={actions}>
                        <label>Pedidos de Titulares</label>
                    </div>
                    <h4>Remoção de Cookies</h4>
                    <div class="ui toggle checkbox">
                        <input type="checkbox" bind:checked={removeCookies}>
                        <label>{removeCookies ? 'Sim' : 'Não'}</label>
                    </div>

                </div>
                <div class="column two section">
                    <div id="picker" class:picker>
                        <dino-color-picker value={color} on:change={onColorChange}></dino-color-picker>
                        <button class="ui tiny blue button" on:click={ () => picker = false}>fechar</button>
                    </div>
                    <h4>Cores</h4>
                    <div class="ui form">
                        <table class="ui basic table">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Valor</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {#each theme as item}
                                    <tr>
                                        <td>{item.title}</td>
                                        <td>
                                            <div class="ui field">
                                                <input type="text" value="{item.value}" on:change={updateTheme(item)}>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="preview" style="background-color: {item.value}" on:click={showPicker(item)}></div>
                                        </td>
                                    </tr>
                                {/each}
                            </tbody>
                        </table>                    
                    </div>    
                </div>
            </div>
        </div>
        <div class="section text">
            <h4>Texto</h4>
            <textarea rows="5" cols="30" bind:value={customText}></textarea>
        </div>
        <div class="ui form section text">
            <h4>Link Politica de Privacidade</h4>
            <div class="ui field">
                <input type="text" bind:value={privacyPolicy}>
            </div>            
        </div>
    </div>
</div>
<style>

    #picker {
        display: none;
        position: absolute;
        padding: 2.7em;
        background-color: #fff;
        _border: 1px solid red;
        top: 120px;
        left: 10px;
        z-index: 10;
    }

    #picker.picker {
        display: flex;
        flex-direction: column;
    }

    dino-color-picker {
        margin-bottom: .5em;
    }

    .preview {
        width: 1em;
        height: 1em;
        border-radius: 2px;
        border: 1px solid #eee;
        cursor: pointer;
    }

    .container {
        display: flex;
        flex-direction: row;
    }

    .settings {
        flex: 1;
        margin: 2em;
    }

    .settings .section {
        margin-top: 2em;
        display: flex;
        flex-direction: column;
    }

    .columns {
        display: flex;
        flex-direction: row;
    }

    .column.one {
        flex: 1;
    }

    .column.two {
        flex: 2;
        position: relative;
    }

    .settings .themes .checkbox {
        margin: 1em 0;
    }

    .settings .text textarea,
    .settings .text textarea:focus,
    .settings .text textarea:active {
        outline: none !important;
        border: 0;
        padding: 1em;
        background-color: #eee;
        border-radius: .4em;
        color: #444;
    }
</style>